// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d7afc32b","453":"8b7b49ac","455":"2f1aa886","977":"aed7a11c"}[chunkId] + ".chunk.js";
};